import moment from "moment";

export const TIME_FORMAT_REGEX = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
export const HHMM_TIME_FORMAT = /^([01]\d|2[0-3]):?([0-5]\d)$/;
export const STOP_TIME_FORMAT_REGEX = /^[0-5]?\d:[0-5]\d$/;
export const MIDNIGHT = "24:00:00";
const STRING_TIME_MATCHER = /(\d{1,2}):(\d{2})(?::(\d{2}))?/;
const SHORT_STRING_TIME_MATCHER = /^(\d{2})(\d{2})$/;

/**
 *
 * @param {String} string support next format HH:MM
 * @returns {number}
 */
export const toMinutes = (stringHHmm = "") => {
  if (!stringHHmm) {
    return 0;
  }

  const timeArr = stringHHmm.split(":");
  return +timeArr[0] * 60 + +timeArr[1];
};

/**
 *
 * @param {String} string support next format HH:MM:SS/HH:MM/HHMM
 * @returns {number}
 */
export const toSeconds = (timeString = "") => {
  if (!timeString) {
    return 0;
  }
  const timeChunks =
    timeString.match(STRING_TIME_MATCHER) ||
    timeString.match(SHORT_STRING_TIME_MATCHER);

  if (timeChunks) {
    const [, hours, minutes, seconds = "0"] = timeChunks;
    return (+hours * 60 + +minutes) * 60 + +seconds;
  }
};

/**
 *
 * @param {number} minutes
 */
export const fromMinutesToTime = (allMinutes) => {
  const hours = Math.floor(Math.abs(allMinutes) / 60)
    .toString()
    .padStart(2, "0");
  const minutes = (Math.abs(allMinutes) % 60).toFixed(0).padStart(2, "0");

  return allMinutes < 0 ? `-${hours}:${minutes}` : `${hours}:${minutes}`;
};

/**
 *
 * @param {number} value in format 56.56
 */
export const formatMinutesToMMSS = (value) => {
  const minutes = Math.floor(value);
  const seconds = Math.round((value % 1) * 100)
    .toFixed(0)
    .padStart(2, "0");
  return value ? `${minutes}:${seconds}` : "00:00";
};

export const isInvalidStopTime = (stringMmSs) =>
  !STOP_TIME_FORMAT_REGEX.test(stringMmSs) || !toMinutes(stringMmSs);

export const getDiffInMinutes = (hhMm1, hhMm2) =>
  toMinutes(hhMm1) - toMinutes(hhMm2);

export const getTime = (value) => moment(value).format("HH:mm");

export const formatSecondsToMMSS = (seconds) =>
  seconds ? moment.utc(seconds * 1000).format("mm:ss") : "00:00";

export const formatSecondsToHHMM = (value) => {
  if (value) {
    const hours = `${Math.floor(value / 3600)}`.padStart(2, "0");
    const minutes = `${Math.floor(value / 60) % 60}`.padStart(2, "0");
    return `${hours}:${minutes}`;
  }
  return "00:00";
};

export const formatStopTime = (time) => {
  const seconds = `${time % 60}`.padStart(2, "0");
  const minutes = `${(time - +seconds) / 60}`.padStart(2, "0");

  return `${minutes}:${seconds}`;
};

export const reformatTime = (strTime, isShort = false) => {
  if (typeof strTime === "string") {
    const timeString = (strTime.match(/\d{2}/g) || []).join(":");
    return isShort ? timeString.slice(0, 5) : timeString;
  }
  return "";
};

export const removeSeconds = (strTime) => strTime.slice(0, 5);

export const createTimeRange = (startTime, endTime) =>
  startTime && endTime
    ? `${reformatTime(removeSeconds(startTime))}-${reformatTime(
        removeSeconds(endTime)
      )}`
    : "";

export const fullTimeToShort = (value) =>
  value ? moment(value, "HH:mm:ss").format("HH:mm") : "00:00";

export const getSecondsFromMMSS = (time) => {
  const [minutes, seconds] = time.split(":");
  if (!minutes || !seconds) {
    return 0;
  }

  return +minutes * 60 + +seconds;
};

export const formatTimeStringWithDefaultMaxValue = (
  timeString,
  defaultValue = ""
) => {
  if (!timeString) {
    return defaultValue;
  }
  const [, hours = "00", minutes = "00"] = timeString.match(
    STRING_TIME_MATCHER
  );
  if (hours > 23) {
    return "23:59";
  }
  return `${hours}:${minutes}`;
};

export const dateToNumber = (date) => new Date(date).valueOf();
